import React from 'react'
import { AiFillGithub } from 'react-icons/ai'
import { FaLinkedinIn, FaInstagram } from 'react-icons/fa'
import Reveal from '../Reveal'

function Home2() {
  return (
    <div className="section section-alt">
      <div className="section-inner">
        <div className="home2-grid">
          <Reveal direction="left">
            <div className="section-tag">about me</div>
            <h2 className="section-title">
              Passionate about <span>building things</span> that matter
            </h2>
            <p style={{ color: 'var(--text-muted)', lineHeight: '1.9', fontSize: '1em', marginBottom: '28px' }}>
              I have developed a deep passion for programming and have acquired substantial
              knowledge in different programming languages. I'm fluent in{' '}
              <strong style={{ color: 'var(--accent)' }}>Python with Machine Learning</strong>, and
              my interests lie in{' '}
              <strong style={{ color: 'var(--accent)' }}>AI, Deep Learning</strong> and{' '}
              <strong style={{ color: 'var(--accent)' }}>Cloud technologies</strong>.
            </p>
            <div style={{ display: 'flex', gap: '12px' }}>
              <a href="https://github.com/Amaan-AeonX" target="_blank" rel="noreferrer"
                style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '42px', height: '42px', borderRadius: '10px', background: 'var(--card-bg)', border: '1px solid var(--card-border)', color: 'var(--accent)', fontSize: '1.2em', textDecoration: 'none', transition: 'all 0.2s ease' }}
                onMouseEnter={e => { e.currentTarget.style.background = 'var(--accent)'; e.currentTarget.style.color = 'white'; }}
                onMouseLeave={e => { e.currentTarget.style.background = 'var(--card-bg)'; e.currentTarget.style.color = 'var(--accent)'; }}
              >
                <AiFillGithub />
              </a>
              <a href="https://www.linkedin.com/in/amaan-akbany5/" target="_blank" rel="noreferrer"
                style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '42px', height: '42px', borderRadius: '10px', background: 'var(--card-bg)', border: '1px solid var(--card-border)', color: 'var(--accent)', fontSize: '1.2em', textDecoration: 'none', transition: 'all 0.2s ease' }}
                onMouseEnter={e => { e.currentTarget.style.background = 'var(--accent)'; e.currentTarget.style.color = 'white'; }}
                onMouseLeave={e => { e.currentTarget.style.background = 'var(--card-bg)'; e.currentTarget.style.color = 'var(--accent)'; }}
              >
                <FaLinkedinIn />
              </a>
              <a href="https://www.instagram.com/maverick_520/" target="_blank" rel="noreferrer"
                style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '42px', height: '42px', borderRadius: '10px', background: 'var(--card-bg)', border: '1px solid var(--card-border)', color: 'var(--accent)', fontSize: '1.2em', textDecoration: 'none', transition: 'all 0.2s ease' }}
                onMouseEnter={e => { e.currentTarget.style.background = 'var(--accent)'; e.currentTarget.style.color = 'white'; }}
                onMouseLeave={e => { e.currentTarget.style.background = 'var(--card-bg)'; e.currentTarget.style.color = 'var(--accent)'; }}
              >
                <FaInstagram />
              </a>
            </div>
          </Reveal>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
            {[
              { label: 'AI/ML', desc: 'Python, FastAPI, LangChain' },
              { label: 'Cloud', desc: 'AWS, GCP, Firebase' },
              { label: 'Vision', desc: 'Computer Vision, IoT' },
              { label: 'Data', desc: 'PostgreSQL, MongoDB, MySQL' },
            ].map((item, i) => (
              <Reveal key={item.label} delay={i * 120} direction="right" style={{ display: 'contents' }}>
              <div style={{ background: 'var(--card-bg)', border: '1px solid var(--card-border)', borderRadius: '16px', padding: '20px', transition: 'all 0.2s ease' }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--accent-light)'; e.currentTarget.style.transform = 'translateY(-3px)'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--card-border)'; e.currentTarget.style.transform = 'translateY(0)'; }}
              >
                <div style={{ fontWeight: 700, color: 'var(--accent)', marginBottom: '6px', fontSize: '0.95em' }}>{item.label}</div>
                <div style={{ fontSize: '0.82em', color: 'var(--text-muted)', fontFamily: '"JetBrains Mono", monospace' }}>{item.desc}</div>
              </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Home2
